import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';


const initialpayTermDataObj = {
    data: [],
    loading: false
};

const TABLE_COLUMNS = [
    {
        header: 'Pay Term Name',

        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row.pay_term}`}
                </span>
            );
        },
    },
    {
        header: 'No. Of Days',
        accessor: 'no_of_days'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    },
];

export const PayTermsForm = ({ getPayTermDropdown, setAddPayTermsOpen }) => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [payTermDataObj, setPayTermDataObj] = useState(initialpayTermDataObj);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();

    const methods = useForm({
        resolver: yupResolver(Yup.object().shape({ pay_term: Yup.string().required('Pay Term is required') })),
        mode: 'all'
    });
    const { handleSubmit, setValue, reset } = methods;

    useEffect(() => {
        if (selectedRecord) {
            setValue('pay_term', selectedRecord.pay_term);
            setValue('no_of_days', selectedRecord.no_of_days);
        } else {
            reset();
        }
    }, [setValue, reset, selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/pay-term-update' : '/pay-term-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: {
                pay_term: formValues.pay_term,
                no_of_days: formValues.no_of_days
            }
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} Manufacturer Details`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            reset();
            handleFetchList()
            getPayTermDropdown()
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} Manufacturer Details`, {
                variant: 'error'
            });
        }
        setLoading(false);
    };

    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/pay-term-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully Cancelled Pay Term master', { variant: 'success' });
            setSelectedRecord();
            handleFetchList()
        } else {
            toast('Failed to cancel Pay Term master', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/pay-term-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Pay Term master', { variant: 'success' });
            setSelectedRecord();
            handleFetchList()
        } else {
            toast('Failed to delete Pay Term master', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleFetchList = async () => {
        setOpenQueryDialog(true);
        setPayTermDataObj({ loading: true });
        const response = await request('/pay-term-list', { method: 'GET' });
        if (response.success) {
            const filteredData = response.data.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setPayTermDataObj({ loading: false, data: filteredData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setPayTermDataObj({ loading: false });
        }
    };
    useEffect(() => {
        handleFetchList()
    }, [])
    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto',
                maxWidth: '100vw',
                minHeight: '100vh'
            }}>
                <Container
                    sx={{
                        mt: 2,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 3,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Manage Pay Terms Details
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        reset();
                                    }}
                                    id={`${lastPathSegment}Write`}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord()
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                        setAddPayTermsOpen(false)
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Stack spacing={2} sx={{ marginBottom: "1%" }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.4, fontSize: '1.6rem', fontWeight: 700 }}>Pay Terms Name</Typography>
                                <TextField
                                    name="pay_term"
                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                    inputProps={{ sx: { fontSize: '1.4rem' } }}
                                    placeholder="Enter Pay Terms Name"
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />

                            </Stack>

                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.4, fontSize: '1.6rem', fontWeight: 700 }}>No. Of Days</Typography>
                                <TextField
                                    name="no_of_days"
                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                    inputProps={{ sx: { fontSize: '1.4rem' } }}
                                    placeholder="Enter Number Of Days"
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />
                            </Stack>
                        </Stack>
                        <Stack
                            padding={1.5}
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            borderBottom="1px solid"
                            borderColor="grey.300"
                        >
                        </Stack>
                        <Table
                            sx={{ mt: 3 }}
                            columns={TABLE_COLUMNS}
                            data={payTermDataObj.data || []}
                            loading={payTermDataObj.loading}
                            onRowClick={(row) => {
                                setSelectedRecord(row);
                                setOpenQueryDialog(false);
                            }}
                        />
                    </FormProvider>
                </Container>
            </Paper >
        </>
    );
};
